<template>
  <div>
    <wc-page-title :title='$store.state.icons.modules.vehicles.title'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            :title='currentDivision.division + " Vehicles"'
            :showAdd='!currentDivision.is_all'
            @add='newVehicle'
            showSearch
            v-model='search'
          >
          <template v-slot:toolbarButtons>
            <wc-show-archived-button v-model='showArchived' @toggleShowArchived='showArchived = !showArchived'></wc-show-archived-button>
          </template>
            <wc-division-tabs v-model='currentDivision'> 
              <v-data-table
                  dense
                  :headers='headers'
                  :items='filteredVehicles'
                  :search='search'
                  :loading='isLoading'
                  sort-by='number'
                  sort-desc
                  @click:row='openItem'
              >
                <template v-slot:item.name='{ item }'>
                  {{ item.name }}
                  <wc-archived v-if='item.archived'></wc-archived>
                </template>
                <template v-slot:item.division_obj.division='{ item }'>
                  <wc-division-nai :division_obj='item.division_obj'></wc-division-nai>
                </template>
                <template v-slot:item.notes='{ item }'>
                  <div class="text-truncate" style='max-width: 450px;' v-html='item.notes'></div>
                  <!-- ellipsis don't show up properly here. using a workaround for now.  -->
                </template>
              </v-data-table>
            </wc-division-tabs>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
    <!-- add new dialog box below  -->
    <wc-dialog
      :showDialog='showDialog'
      :title='dialogTitle'
      :icon='currentDivision.icon'
      :iconColor='currentDivision.iconColor'
      @cancel='cancelEdit'
      @save='saveEdit'
      :loading='isLoading'
      :disableButtons='!isFormValid'
      lazy-validation
    >
      <v-form v-model="isFormValid" ref='form'>
        <v-select
          :items='divs'
          item-value='id'
          item-text='division'
          label='Division'
          v-model='newItem.division'
          @change='updateDivision'
        ></v-select>
        <v-text-field
          label='Name'
          ref='name'
          :rules='[v => !!v || "A name is required (but this is the only required item. For reals!)"]'
          v-model='newItem.name'
        ></v-text-field>
        <v-row>
          <v-col cols='12' sm='6' md='4'>
            <v-text-field
              label='Year'
              ref='year'
              v-model='newItem.year'
            ></v-text-field>
          </v-col>
          <v-col cols='12' sm='6' md='4'>
            <v-text-field
              label='Make'
              ref='make'
              v-model='newItem.make'
            ></v-text-field>
          </v-col>
          <v-col cols='12' sm='6' md='4'>
            <v-text-field
              label='Model'
              ref='model'
              v-model='newItem.model'
            ></v-text-field>
          </v-col>
          <v-col cols='12' sm='6' md='4'>
            <v-text-field
              label='Color'
              ref='color'
              v-model='newItem.color'
            ></v-text-field>
          </v-col>
          <v-col cols='12' sm='6' md='4'>
            <v-text-field
              label='Licence plate'
              v-model='newItem.license_plate'
            ></v-text-field>
          </v-col>
          <v-col cols='12' sm='6' md='4'>
            <v-text-field
              label='VIN'
              v-model='newItem.vin'
            ></v-text-field>
          </v-col>
        </v-row>
        <br>
        <span>Notes</span>
        <v-textarea outlined auto-grow v-model='newItem.notes'></v-textarea>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
  import assetsAPI from '@/modules/assets/api/vehicles'
  import _ from 'lodash'
  import formRules from '@/mixins/formRules'

  export default {
    name: 'all-vehicles',
    mixins: [formRules],
    data: () => ({
      currentDivision: {},
      resetItem: {
        name: "",
        vin: '',
        year: null,
        make: '',
        model: '',
        color: '',
        license_plate: '',
        notes: "",
      },
      newItem: {},
      isLoading: true,
      showDialog: false,
      showArchived: false,
      isFormValid: true,
      search: "",
      vehicles: [],
      headers: [
        { text: 'Name', value: 'name', width: '135' },
        // { text: 'Division', value: 'division_obj.division', align: 'center' },  // this is redundant due to tabs
        { text: 'Year', value: 'year', width: '135' },
        { text: 'Color', value: 'color',width: '135' },
        { text: 'Make', value: 'make', width: '135' },
        { text: 'Model', value: 'model', width: '135' },
        { text: 'Notes', value: 'notes', }
      ]
    }),
    mounted () {
      this.getVehicles()
      this.itemReset()
      this.currentDivision = 'All' // eventually this can be set to a user defined value - use this.divs[n]
    },
    computed: {
      divisionedVehicles () {
        if (!this.currentDivision.is_all) {
          return this.vehicles.filter(inv => inv.division === this.currentDivision.id)
        }
        else { return this.vehicles }
      },
      filteredVehicles () {
        if (!this.showArchived) {
          return this.divisionedVehicles.filter(i => i.archived === false)
        }
          else { return this.divisionedVehicles }
      },
      dialogTitle () {
        return "Add a new " + this.currentDivision.division + " vehicle (or trailer)"
      },
      divs () {
        return _.orderBy(this.$store.state.misc.divisions, 'order')
      },
    },
    methods: {
      updateDivision () {
        this.currentDivision = this.divs[_.findIndex(this.divs, ['id', this.newItem.division])]
      },
      async getVehicles () {
        this.isLoading = true
        this.vehicles = await assetsAPI.getVehicles()
        this.isLoading = false
      },
      newVehicle () {
        this.showDialog = true
        this.itemReset()
        this.newItem.division = this.currentDivision.id
        setTimeout(() => {
          this.$refs.form.resetValidation()
        }, 50)
        setTimeout(() => {
          this.$refs.name.focus()
        }, 100)
      },
      cancelEdit () {
        this.showDialog = false
      },
      openItem (item) {
        this.$router.push({ name: 'VehicleDetailOverview', params: { id: item.id } })
      },
      async saveEdit () {
        this.isLoading = true
        console.log(this.newItem)
        this.vehicles.push(await assetsAPI.newVehicle(this.newItem))
        this.isLoading = false
        this.showDialog = false
      },
      itemReset() {
        this.newItem = _.cloneDeep(this.resetItem)
      }
    }
  }
</script>
